import { useDotLegalQuery } from "@common/hooks/dotLegalReactQuery.ts";
import { SystemStepTabProps } from "./SystemStepTab.tsx";
import { OverviewStep } from "@common/components/overviewStepSection/OverviewStepSection.types.ts";

export function useSystemStepTab(props: SystemStepTabProps) {
    const url = `/SystemOverview/${props.systemId}/steps/${props.stepId}`;
    const { isLoading, data } = useDotLegalQuery<OverviewStep>(url);

    return {
        isLoading,
        data,
    };
}
